<template>
    <div v-show="can.create.bookable">
        <button-secondary @click="open()">
            <template slot="icon"><i class="fa fa-plus"></i></template> {{ category.name }} hinzufügen
        </button-secondary>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">{{ category.name }} hinzufügen</template>

                <input-text v-model="name" class="mb-4">
                    Name
                </input-text>

                <div class="flex justify-end">
                    <button-primary @click="store"><template slot="icon"><i class="fa fa-plus"></i></template> Hinzufügen</button-primary>
                </div>
            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonSecondary from "../UI/ButtonSecondary";
import Modal from "../Modal";
import ButtonPrimary from "../UI/ButtonPrimary";
import InputText from "../UI/InputText";

export default {
    name: "BookableCreate",

    components: {InputText, ButtonPrimary, Modal, ButtonSecondary},

    inject: ['can'],

    props: ['category'],

    data: () => ({
        showModal: false,
        name: '',
        persons: 0,
    }),

    methods: {
        open() {
            this.name = '';
            this.showModal = true;
        },
        store() {
            window.axios.post('/admin/bookables', {
                name: this.name,
                bookable_category_id: this.category.id,
            }).then(() => {
                this.showModal = false;
                this.$emit('created');
            }).catch(error => {
                this.$root.$emit('error', error);
            })
        }
    }
}
</script>

<style scoped>

</style>
